export default __webpack_public_path__ + "static/media/img5.95db93f9.png";